import loginStyles from '../../Login/index.module.scss';
import SignUpForm from './SignUpForm';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import formStyles from '../../Login/LoginContent/index.module.scss';
import { useSignUpService } from '../../../services/signUpService';
import { isEmpty } from 'lodash';
import BackButton from '../BackButton';

function SignUpContent() {
  const {
    state,
    challenge,
    state: { signUpMethod, signUpFlowState },
  } = useSignUpService();

  return (
    <div
      className={classNames(formStyles.root, loginStyles.boxContainer, 'w-full', {
        [loginStyles.hide]: !signUpMethod || !isEmpty(challenge) || !!signUpFlowState.state,
      })}
    >
      <BackButton onClick={() => state.resetSignupStates()} />
      <span className={classNames(loginStyles.title)}>{`Sign up with ${
        signUpMethod === 'email' ? 'Email' : signUpMethod
      }`}</span>
      <SignUpForm />
    </div>
  );
}
export default observer(SignUpContent);
